<template>
    <DefaultField :field="currentField" :errors="errors" :show-help-text="showHelpText">
        <template #field>
            <input
                :id="currentField.attribute"
                type="text"
                inputmode="numeric"
                class="w-full form-control form-input form-input-bordered"
                :class="errorClasses"
                :placeholder="currentField.name"
                v-model="displayValue"
                @input="handleInput"
            />
            <p v-if="numbersText" class="text-sm text-gray-600 dark:text-gray-400 mt-1">
                {{ numbersText }}
            </p>
        </template>
    </DefaultField>
</template>

<script>
import { DependentFormField, HandlesValidationErrors } from '@/mixins'
import numeral from 'numeral'
import pn from 'persian-number'

const PERSIAN_DIGITS = '۰۱۲۳۴۵۶۷۸۹'
const ARABIC_DIGITS = '٠١٢٣٤٥٦٧٨٩'

export default {
    mixins: [DependentFormField, HandlesValidationErrors],

    props: ['resourceName', 'resourceId', 'field'],

    data() {
        return {
            numbersText: '',
        }
    },

    computed: {
        displayValue: {
            get() {
                if (this.value === null || this.value === undefined || this.value === '') {
                    return ''
                }

                // English raw value → grouped English → Persian digits for display
                return this.toPersianDigits(
                    numeral(this.value).format(this.currentField.format || '0,0')
                )
            },

            set(newValue) {
                // Accept Persian/Arabic/English digits, keep English integer behind the scenes
                const englishInput = this.toEnglishDigits(newValue)
                const raw = numeral(englishInput).value()
                const normalized = raw === null || Number.isNaN(raw) ? '' : Math.round(raw)

                this.value = normalized === '' ? '' : normalized
                this.updateNumbersText(normalized)
                this.emitFieldValueChange(this.fieldAttribute, this.value === '' ? '' : this.value)
            },
        },
    },

    methods: {
        setInitialValue() {
            this.value = this.field.value ?? ''
            this.updateNumbersText(this.value)
        },

        fill(formData) {
            // Always submit English digits
            formData.append(this.field.attribute, this.value === '' ? '' : this.value)
        },

        handleInput(event) {
            this.displayValue = event.target.value
        },

        toEnglishDigits(value) {
            return String(value ?? '')
                .replace(/[۰-۹]/g, digit => String(PERSIAN_DIGITS.indexOf(digit)))
                .replace(/[٠-٩]/g, digit => String(ARABIC_DIGITS.indexOf(digit)))
        },

        toPersianDigits(value) {
            return String(value ?? '').replace(/\d/g, digit => PERSIAN_DIGITS[digit])
        },

        updateNumbersText(value) {
            if (value === '' || value === null || value === undefined) {
                this.numbersText = ''

                return
            }

            const raw = Number(value)

            if (! Number.isFinite(raw)) {
                this.numbersText = ''

                return
            }

            const unit = this.currentField.moneyUnit || ''
            const text = pn.convert(raw)

            this.numbersText = unit ? `${text} ${unit}` : text
        },
    },
}
</script>
